import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import dig from 'object-dig';

import Typography from '@material-ui/core/Typography';

import LinearProgress from '~/components/LinearProgress';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputControl from '~/components/Input/InputControl';
import InputTextEditor from '~/components/Input/InputTextEditor';
import InputFile from '~/components/Input/InputFile';
import InputMultiIds from '~/components/Input/InputMultiIds';
import ExpandableSection from '~/components/ExpandableSection';

const labelStyle = {
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: '2px',
  marginBottom: '-5px',
};

const labelTextStyle = { color: '#444', fontWeight: 400 };

const optionalLabelStyle = {
  color: 'red',
  fontWeight: 400,
  paddingLeft: '5px',
};

const requiredLabelStyle = {
  color: '#d32f2f',
  fontWeight: 400,
  paddingLeft: '2px',
};

function FieldLabel({ label, optional, required }) {
  return (
    <div style={labelStyle}>
      <Typography variant="caption" style={labelTextStyle}>
        {label}
      </Typography>
      {required && (
        <Typography variant="caption" style={requiredLabelStyle}>
          *
        </Typography>
      )}
      {optional && (
        <Typography variant="caption" style={optionalLabelStyle}>
          (Não Obrigatório)
        </Typography>
      )}
    </div>
  );
}

function ModalMedicalRecordEvolutionForm({
  setFiles,
  loading,
  evolution,
  handleChangeEvolutionText,
  handleChangeMainObject,
  countryIdCompany,
}) {
  const { t } = useTranslation();

  const [cid, setCid] = useState([]);
  const [secondaryCid, setSecondaryCid] = useState([]);
  const [exit, setExit] = useState([]);

  const [cidId, setCidId] = useState([]);
  const [secondaryCidId, setSecondaryCidId] = useState([]);
  const [exitId, setExitId] = useState([]);

  const [expandedPanel, setExpandedPanel] = useState('evolucao');

  const handlePanelChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  useEffect(() => {
    handleChangeMainObject({
      cid: cidId,
      secondaryCid: secondaryCidId,
      exit: exitId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cid, secondaryCid, exit]);

  return (
    <>
      <LinearProgress loading={loading} />

      {countryIdCompany === 2 && (
        <GridContainer>
          <GridItem xs={12}>
            <Typography variant="caption" style={labelTextStyle}>
              Evolução
            </Typography>
            <InputControl
              value={dig(evolution, 'notes')}
              name="notes"
              inputComponent={InputTextEditor}
              onChange={handleChangeEvolutionText}
            />
          </GridItem>
        </GridContainer>
      )}

      {countryIdCompany === 1 && (
        <>
          {/* 1. EVOLUÇÃO */}
          <ExpandableSection
            title="Evolução"
            required
            expanded={expandedPanel === 'evolucao'}
            onChange={handlePanelChange}
            panelId="evolucao"
          >
            <GridContainer>
              <GridItem xs={12}>
                <InputControl
                  value={dig(evolution, 'notes')}
                  name="notes"
                  inputComponent={InputTextEditor}
                  onChange={handleChangeEvolutionText}
                />
              </GridItem>
            </GridContainer>
          </ExpandableSection>

          {/* 2. INFORMAÇÕES GERAIS */}
          <ExpandableSection
            title="Informações Gerais"
            required
            expanded={expandedPanel === 'info'}
            onChange={handlePanelChange}
            panelId="info"
          >
            <GridContainer>
              <GridItem xs={12}>
                <FieldLabel label="CID Principal" required />
                <InputMultiIds
                  type="cid"
                  stateExternal={cid}
                  setStateExternal={setCid}
                  setStateId={setCidId}
                />
              </GridItem>
              <GridItem xs={12}>
                <FieldLabel label="CID Secundário" optional />
                <InputMultiIds
                  type="cidsec"
                  stateExternal={secondaryCid}
                  setStateExternal={setSecondaryCid}
                  setStateId={setSecondaryCidId}
                />
              </GridItem>
              <GridItem xs={12}>
                <FieldLabel label="Saída de Atendimento" required />
                <InputMultiIds
                  type="exitCode"
                  stateExternal={exit}
                  setStateExternal={setExit}
                  setStateId={setExitId}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12}>
                {loading && (
                  <LinearProgress style={{ height: 4 }} color="secondary" />
                )}
                <InputFile
                  label={t('dropzone_file_placeholder')}
                  onChange={(files) => setFiles(files)}
                />
              </GridItem>
            </GridContainer>
          </ExpandableSection>
        </>
      )}

      <LinearProgress loading={loading} />
    </>
  );
}

ModalMedicalRecordEvolutionForm.propTypes = {
  loading: PropTypes.bool,
  evolution: PropTypes.object,
  setFiles: PropTypes.func.isRequired,
  handleChangeEvolutionText: PropTypes.func.isRequired,
  handleChangeMainObject: PropTypes.func.isRequired,
  countryIdCompany: PropTypes.number,
};

ModalMedicalRecordEvolutionForm.defaultProps = {
  loading: false,
  evolution: null,
  countryIdCompany: null,
};

export default ModalMedicalRecordEvolutionForm;
